var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6006_27216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74219 26.25H26.2422",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74219 8.75098V10.001C3.74219 10.9955 4.13728 11.9494 4.84054 12.6526C5.5438 13.3559 6.49763 13.751 7.49219 13.751C8.48675 13.751 9.44058 13.3559 10.1438 12.6526C10.8471 11.9494 11.2422 10.9955 11.2422 10.001M3.74219 8.75098H26.2422M3.74219 8.75098L6.24219 3.75098H23.7422L26.2422 8.75098M11.2422 10.001V8.75098M11.2422 10.001C11.2422 10.9955 11.6373 11.9494 12.3405 12.6526C13.0438 13.3559 13.9976 13.751 14.9922 13.751C15.9867 13.751 16.9406 13.3559 17.6438 12.6526C18.3471 11.9494 18.7422 10.9955 18.7422 10.001M18.7422 10.001V8.75098M18.7422 10.001C18.7422 10.9955 19.1373 11.9494 19.8405 12.6526C20.5438 13.3559 21.4976 13.751 22.4922 13.751C23.4867 13.751 24.4406 13.3559 25.1438 12.6526C25.8471 11.9494 26.2422 10.9955 26.2422 10.001V8.75098",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25781 26.251V13.5635",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 26.251V13.5635",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2422 26.25V21.25C11.2422 20.587 11.5056 19.9511 11.9744 19.4822C12.4433 19.0134 13.0791 18.75 13.7422 18.75H16.2422C16.9052 18.75 17.5411 19.0134 18.01 19.4822C18.4788 19.9511 18.7422 20.587 18.7422 21.25V26.25",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6006_27216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingActive);
export default __webpack_public_path__ + "static/media/marketingActive.3446716e26745277bf273776d58b63ec.svg";
export { ForwardRef as ReactComponent };